import React from 'react';

export const ArrowRightSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 171 171"
      width="30px"
      height="30px"
    >
      <g
        style={{ mixBlendMode: 'normal' }}
        fill="none"
        strokeMiterlimit="10"
        fontFamily="none"
        fontSize="none"
        fontWeight="none"
        textAnchor="none"
      >
        <path d="M0,171.99374v-171.99374h171.99374v171.99374z" />
        <path
          fill="#faf9f9"
          d="M126.74039,44.3932c-2.77875,-0.10687 -5.35711,1.48289 -6.49266,4.02117c-1.1489,2.53828 -0.65461,5.50406 1.26914,7.53469l21.0143,22.71094h-132.27117c-2.47148,-0.04008 -4.75594,1.25578 -5.99836,3.39328c-1.25578,2.12414 -1.25578,4.7693 0,6.89344c1.24242,2.1375 3.52687,3.43336 5.99836,3.39328h132.27117l-21.0143,22.71094c-1.71,1.79016 -2.31117,4.35516 -1.58977,6.71977c0.72141,2.36461 2.65852,4.15477 5.0632,4.68914c2.41805,0.53437 4.92961,-0.28055 6.57281,-2.11078l35.92336,-38.84906l-35.92336,-38.84906c-1.22906,-1.36265 -2.97914,-2.19094 -4.82273,-2.25773z"
        />
      </g>
    </svg>
  );
};
